import { MessageImage, Image } from './ErrorMessageView.styled';

const ErrorMessageViev = () => {
  return (
    <MessageImage>
      <Image
        src="https://www.boredpanda.com/blog/wp-content/uploads/2017/09/saddest-cat-luhu-maggie-liu-lanlan731-38-59c0bfed09657__700.jpg"
        alt=""
      />
      <p>Didn't find anything</p>
    </MessageImage>
  );
};

export default ErrorMessageViev;
